import React from "react";
import { useState } from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import "../../SalesMasterPages/DashboardTest/DashboardTest.css";
import image1 from "../../../images/Op1.PNG"
import image2 from "../../../images/Op2.PNG"
const DashboardTest = () => {

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div>
            <img

              src={image1}
              style={{ background: "white", width: "100%" }}
            />
          </div>

          <div>
            <img


              src={image2}
              style={{ background: "white", width: "100%" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardTest;
